export const PostAcquisitionImportFieldSettings = [
    {
        "width": 95,
        "field": "sourceId",
        "displayName": "Source ID",
        "tooltip": "Opportunity Source ID",
        "type": "string",
        "required": true,
        "maxLength": 100,
        "fieldToLowerCase": "sourceid"
    },
    {
        "width": 160,
        "field": "street",
        "displayName": "Street",
        "tooltip": "Street Address",
        "type": "string",
        "required": true,
        "maxLength": 100,
        "fieldToLowerCase": "street"
    },
    {
        "width": 115,
        "field": "city",
        "displayName": "City",
        "type": "string",
        "required": true,
        "maxLength": 100,
        "fieldToLowerCase": "city"
    },
    {
        "width": 70,
        "field": "state",
        "displayName": "State",
        "type": "string",
        "required": true,
        "maxLength": 100,
        "fieldToLowerCase": "state"
    },
    {
        "width": 91,
        "field": "zipCode",
        "displayName": "Zip Code",
        "type": "string",
        "required": true,
        "maxLength": 10,
        "fieldToLowerCase": "zipcode"
    },
    {
        "width": 94,
        "field": "yearBuilt",
        "displayName": "Year Built",
        "type": "number",
        "required": true,
        "fieldToLowerCase": "yearbuilt"
    },
    {
        "width": 78,
        "field": "sqft",
        "displayName": "Square Feet",
        "type": "number",
        "required": true,
        "format": {
            "type": "fixedPoint",
            "precision": 0
        },
        "fieldToLowerCase": "squarefeet"
    },
    {
        "width": 70,
        "field": "beds",
        "displayName": "Beds",
        "tooltip": "Number of Beds",
        "type": "number",
        "required": true,
        "format": {
            "type": "decimal",
            "precision": 1
        },
        "fieldToLowerCase": "beds"
    },
    {
        "width": 72,
        "field": "baths",
        "displayName": "Baths",
        "tooltip": "Number of Baths",
        "type": "number",
        "required": true,
        "format": {
            "type": "decimal",
            "precision": 1
        }
},
    {
        "width": 72,
        "field": "notes",
        "displayName": "Notes",
        "type": "string",
        "maxLength": 8000,
        "fieldToLowerCase": "notes"
    }
]